<modal-container
  #modal
  [headerIconClass]="'fa-download'"
  [headerTitle]="'import.do'"
  [ignoreBackdropClick]="true"
  [isLargeModal]="false"
>
  <ng-container class="modal-button-show">
    <btn
      [label]="'import.do'"
      [title]="'import.do' | translate"
      [icon]="'far-download'"
      [isLoading]="loading"
      [spinnerClassesString]="'spinner-blue'"
      [classes]="['btn-third', 'me-2']"
      (onEvent)="showChildModal()"
      [attr.data-cy]="'modal-purchase-orders-import-open'"
    ></btn>
  </ng-container>

  <ng-container class="modal-body-content">
    <div class="card">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      @if (!isImportMapUpdating && !isImportMapSet) {
        <div>
          <div class="row">
            <div class="col-12">
              <form-row-select
                [label]="'batch.file.type'"
                [icon]="'far-list'"
                [(model)]="selectedFileType"
                [options]="fileTypes"
              ></form-row-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 ps-0 pe-0" style="font-size: 12px">
              @if (selectedFileType === 'depoto-purchase-orders.xlsx') {
                <div class="col-12 flex-gap-5 align-items-center">
                  <span>{{ 'modal-purchase-orders-import.template' | translate }}</span>
                  <a
                    class="inline-flex-gap-5 align-items-center"
                    [href]="templatesURL + 'depoto-purchase-orders' + ('lang-url-fragment' | translate) + '.tpl.xlsx'"
                  >
                    <span class="far fa-file-download"></span>
                    <span>{{ 'modal-purchase-orders-import.name' | translate }}</span>
                  </a>
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <form-row-input
                [label]="'file'"
                [icon]="'far-upload'"
                [inputType]="'file'"
                [appendBtnLabel]="'load'"
                [appendBtnClasses]="['btn-input']"
                [dataCyAttribute]="'modal-purchase-orders-import-file'"
                (valueChangeNative)="loadFile($event)"
                (onAppendBtnEvent)="handleImportFile()"
              ></form-row-input>
            </div>
          </div>
        </div>
      }
      @if (isImportMapSet) {
        <progressbar type="success" [value]="progress" [striped]="true" [max]="100"></progressbar>
      }
      <span class="sr-only">{{ progress }}{{ 'modal-products-import.done' | translate }}</span>
      @if (isImportMapUpdating || (!isImportMapSet && worksheetNames.length > 1)) {
        <div class="mt-2">
          <h3>{{ 'modal-purchase-orders-import.check-column-layout' | translate }}</h3>
          @if (worksheetNames.length > 1) {
            <div class="row">
              <div class="col-12">
                <form-row-select
                  [label]="'modal-purchase-orders-import.worksheet'"
                  [model]="selectedWorksheetName"
                  [options]="worksheetNames"
                  [isSelectDisabled]="loading"
                  [dataCyAttribute]="'modal-purchase-orders-import-worksheet'"
                  (modelChange)="selectWorksheet($event)"
                ></form-row-select>
              </div>
            </div>
          }
          @if (worksheetNames.length > 1) {
            <hr class="worksheet-divider" data-cy="modal-purchase-orders-import-worksheet-divider" />
          }
          @if (isImportMapUpdating) {
            <div data-cy="modal-purchase-orders-import-mapping">
              <div class="row">
                <div class="col-6">
                  <form-row-select
                    [label]="'purchaseOrder.supplierReference'"
                    [(model)]="importMap.supplierReference"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-supplier-reference'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'ean'"
                    [(model)]="importMap.ean"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-ean'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'code'"
                    [(model)]="importMap.code"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-code'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'product.name'"
                    [(model)]="importMap.productName"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-product-name'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'quantity'"
                    [(model)]="importMap.quantity"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-quantity'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'purchaseOrder.purchasePriceWithoutVat'"
                    [(model)]="importMap.purchasePriceWithoutVat"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-purchase-price-without-vat'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'currency'"
                    [(model)]="importMap.currency"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-currency'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'depot'"
                    [(model)]="importMap.depot"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-depot'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'supplier'"
                    [(model)]="importMap.supplier"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-supplier'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'purchaseOrder.reference'"
                    [(model)]="importMap.reference"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-reference'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'purchaseOrder.dateOfExpectedReceipt'"
                    [(model)]="importMap.dateEstimatedArrival"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-date-estimated-arrival'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'orderNote'"
                    [(model)]="importMap.note"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-note'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'privateNote'"
                    [(model)]="importMap.privateNote"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-private-note'"
                  ></form-row-select>
                </div>
                <div class="col-6">
                  <form-row-select
                    [label]="'itemNote'"
                    [(model)]="importMap.itemNote"
                    [options]="columnTypes"
                    [dataCyAttribute]="'modal-purchase-orders-import-column-item-note'"
                  ></form-row-select>
                </div>
              </div>
              <btn
                [btnType]="'button'"
                [label]="'continue'"
                [title]="'continue' | translate"
                (onEvent)="setImportMapAndContinue()"
                [attr.data-cy]="'modal-purchase-orders-import-continue'"
              ></btn>
            </div>
          }
        </div>
      }
      @if (isImportFileLoaded) {
        <div class="mt-2">
          <alert type="info"
            >{{ purchaseOrders.length }} {{ 'modal-purchase-orders-import.items-ready' | translate }}</alert
          >
        </div>
      }
      @if (errors && errors.length > 0) {
        <div class="mt-2">
          <div class="mb-2">{{ 'failed.to.import' | translate }}</div>
          <div class="import-errors" data-cy="modal-purchase-orders-import-errors">
            @for (e of errors; track e) {
              <alert type="warning" data-cy="modal-purchase-orders-import-error">
                @if (e.orderIdentifier) {
                  <strong>
                    {{
                      'modal-purchase-orders-import.error-order'
                        | translate
                          : {
                              identifier: e.orderIdentifier
                            }
                    }}:
                  </strong>
                }
                @if (!e.orderIdentifier && e.rowNumber) {
                  <strong>
                    {{
                      'modal-purchase-orders-import.error-row'
                        | translate
                          : {
                              row: e.rowNumber
                            }
                    }}:
                  </strong>
                }
                {{ e?.message | translate: e?.params }}
              </alert>
            }
          </div>
        </div>
      }
    </div>
  </ng-container>

  <ng-container class="modal-footer-content">
    <btn
      [label]="'import.do'"
      [title]="'import.do' | translate"
      [icon]="'far-download'"
      [classes]="['btn-first']"
      [btnDisabled]="!isImportFileLoaded || loading || !purchaseOrders?.length"
      (onEvent)="import()"
    ></btn>
  </ng-container>
</modal-container>
